import React from 'react';
import { Col } from '@lwt-helix/layout';
import { FormGroup } from '@lwt-helix/form';
import PropTypes from 'prop-types';

export const SectionColumn = ({ colProps, dataTestId, title, children }) => (
    <Col {...colProps}>
        <FormGroup>
            <div data-lwt-id={`lbl-${dataTestId}`} className="filter-header">
                {title}
            </div>
            {children}
        </FormGroup>
    </Col>
);

SectionColumn.propTypes = {
    colProps: PropTypes.object,
    dataTestId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};
